import {
  Form,
  Input,
  Button,
  Typography,
  Row,
  Col,
  Card,
  Space,
  Image,
  Modal,
  notification,
  Grid,
} from 'antd';

import Recaptcha from 'components/recaptcha';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setUserData } from 'redux/slices/auth';
import { fetchRestSettings, fetchSettings } from 'redux/slices/globalSettings';
import { useTranslation } from 'react-i18next';
import authService from 'services/auth';
import { useTurnstile } from './captcha-hook';

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const Login = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [recaptcha, setRecaptcha] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [emailForReset, setEmailForReset] = useState('');
  const navigate = useNavigate();
  const [isOtpModalVisible, setIsOtpModalVisible] = useState(false);
  const [emailForOtp, setEmailForOtp] = useState('');
  const [otp, setOtp] = useState('');
  const [isPasswordResetModalVisible, setIsPasswordResetModalVisible] =
    useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const screens = useBreakpoint();

  useTurnstile('turnstile-container', (token) => setRecaptcha(token));


  

  const requestOtpOrLogin = (emailValue, passwordValue) => {
    const body = {
      password: passwordValue,
    };
    if (emailValue.includes('@')) {
      body.email = emailValue;
    } else {
      body.phone = emailValue.replace(/[^0-9]/g, '');
    }

    body.captchaField = recaptcha;
    setLoading(true);
    return authService
      .login(body)
      .then((res) => {
        const data = res?.data || res; // request.js returns response.data; keep safe
        const user = data?.user;
        if (user && data?.access_token) {
          const normalizedUser = {
            ...user,
            fullName: `${user.firstname || ''} ${user.lastname || ''}`.trim(),
          };
          localStorage.setItem('token', data.access_token);
          dispatch(setUserData(normalizedUser));
          dispatch(user.role === 'admin' ? fetchSettings({}) : fetchRestSettings({}));
          navigate('/dashboard', { replace: true });
          return;
        }
        if (data?.require_otp && data?.temp_token) {
          console.log("data.. ", data)
          
          notification.info({ message: data?.message || 'OTP sent to your email.' });
          try {
            const payload = { identifier: emailValue, password: passwordValue };
            sessionStorage.setItem('otp_login_payload', JSON.stringify(payload));
            if (data?.time) {
              sessionStorage.setItem('otp_sent_time', data.time);
              sessionStorage.setItem('otp_token_payload', data.time);
            }
          } catch {}
          console.log("navigating...")
          navigate(`/login/otp?temp_token=${encodeURIComponent(data.temp_token)}&email=${encodeURIComponent(data.email || emailValue)}`);
          return;
        } else {
          notification.error({ message: data?.message || 'Login failed' });
        }
      })
      .catch((error) => {
        const data = error?.response?.data;
        if (data?.require_otp && data?.temp_token) {
          notification.info({ message: data?.message || 'OTP sent to your email.' });
          try {
            const payload = { identifier: emailValue, password: passwordValue };
            sessionStorage.setItem('otp_login_payload', JSON.stringify(payload));
            if (data?.time) {
              sessionStorage.setItem('otp_sent_time', data.time);
            }
          } catch {}
          navigate(`/login/otp?temp_token=${encodeURIComponent(data.temp_token)}&email=${encodeURIComponent(data.email || emailValue)}`);
          return;
        }
        notification.error({ message: data?.message || 'Login failed' });
      })
      .finally(() => setLoading(false));
  };

  const handleLogin = (values) => {
    requestOtpOrLogin(values.email, values.password);
  };

  // OTP login moved to /login/otp page

  // OTP resend handled on /login/otp page

  const handleForgotPassword = () => {
    setIsModalVisible(true); // Show the forgot password modal
  };

  const handlePasswordReset = () => {
    if (!emailForReset) {
      notification.error({
        message: 'Please enter a valid email address',
      });
      return;
    }
    setLoading(true);
    authService
      .requestPasswordReset(emailForReset)
      .then((res) => {
        notification.success({
          message: 'Password reset link sent to your email.',
        });
        setEmailForOtp(emailForReset);
        setIsModalVisible(false);
        setIsOtpModalVisible(true);
      })
      .catch((error) => {
        // notification.error({
        //   message: 'Error sending password reset link.',
        // });
      })
      .finally(() => setLoading(false));
  };

  const handleOtpValidation = () => {
    if (!otp) {
      notification.error({
        message: 'Please enter the OTP',
      });
      return;
    }
    setLoading(true);
    authService
      .verifyOtp(emailForOtp, otp)
      .then((res) => {
        localStorage.setItem('token', res.data.token);
        notification.success({
          message:
            'OTP validated successfully. Proceeding to reset password...',
        });

        setIsOtpModalVisible(false); // Close OTP modal
        setIsPasswordResetModalVisible(true); // Show password reset modal
      })
      .catch((error) => {
        console.error('error', error);
        notification.error({
          message: 'Invalid OTP. Please try again.',
        });
      })
      .finally(() => setLoading(false));
  };

  const handlePasswordResetSubmit = () => {
    if (!newPassword || !confirmPassword) {
      notification.error({
        message: 'Please fill in all fields!',
      });
      return;
    }

    if (newPassword !== confirmPassword) {
      notification.error({
        message: 'Passwords do not match!',
      });
      return;
    }

    setLoading(true);

    authService
      .resetPassword({
        password: newPassword,
        password_confirmation: confirmPassword,
      })
      .then(() => {
        notification.success({
          message: 'Password reset successfully!',
        });
        setIsPasswordResetModalVisible(false);
      })
      .catch((error) => {
        console.error('Password reset error:', error);
        notification.error({
          message: 'Failed to reset password. Please try again.',
        });
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    dispatch(fetchRestSettings({}));
  }, []);

  return (
    <Row
      style={{
        backgroundColor: '#ffffff', // Automatically switches based on theme
        minHeight: '100vh',
      }}
      gutter={[16, 16]}
    >
      {/* Left Section */}
      {screens.md && (
        <Col
          md={12}
          style={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            color: 'white',
            backgroundImage: "url('/suit.jpg')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(246, 166, 9, 0.9)',
            }}
          />
          <Space
            direction='vertical'
            size={0}
            style={{ position: 'relative', zIndex: 1 }}
          >
            <Title
              style={{ color: 'white', fontSize: '36px', fontWeight: 'bold' }}
            >
              Welcome To
            </Title>
            <Image src='/tina_logo_1.png' width={screens.lg ? 400 : 300} />
          </Space>
        </Col>
      )}
      {!screens.md && (
        <div
          style={{
            width: '100%',
            height: '60px', // Navbar height
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 1000,
          }}
        >
          <Image src='/tina_logo_2.png' width={120} />
        </div>
      )}

      {/* Right Section */}
      <Col
        xs={24}
        md={12}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Card
          style={{
            width: screens.sm ? 350 : '100%',
            textAlign: 'center',
            backgroundColor: '#ffffff',
            border: 'none',
          }}
        >
          <Title
            level={4}
            style={{
              fontWeight: 'bold',
              fontSize: '30px',
              marginBottom: '50px',
              color: 'black',
            }}
          >
            Sign in
          </Title>

          <Form
            layout='vertical'
            onFinish={handleLogin}
            style={{ marginTop: 20 }}
          >
            <Form.Item
              name='email'
              rules={[{ required: true, message: 'Please enter your email!' }]}
              style={{ textAlign: 'start' }}
            >
              <Input
                style={{
                  background: '#ffffff',
                  color: 'black',
                  boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.1)',
                  border: 'none',
                  height: '60px',
                  fontSize: '16px',
                  marginBottom: '2px',
                }}
                placeholder='Email'
              />
            </Form.Item>
            <Form.Item
              name='password'
              rules={[
                { required: true, message: 'Please enter your password!' },
              ]}
            >
              <Input.Password
                style={{
                  background: '#ffffff',
                  color: 'black',
                  boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.1)',
                  border: 'none',
                  height: '60px',
                  fontSize: '16px',
                  marginBottom: '2px',
                }}
                placeholder='Password'
              />
            </Form.Item>
            {/* <div style={{ marginTop: '20px', marginBottom: '20px' }}>
              <Recaptcha onChange={handleRecaptchaChange} />
            </div> */}

            <div style={{ marginTop: '20px', marginBottom: '20px' }}>
              {/* <Recaptcha onChange={handleRecaptchaChange} /> */}
              <div id="turnstile-container"></div>

            </div>
            <Button
              block
              type='primary'
              htmlType='submit'
              style={{
                width: 'full',
                boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.1)',
                border: 'none',
                backgroundColor: 'rgba(246, 166, 9, 0.9)',
                color: 'white',
                marginBottom: '20px',
              }}
              className='login-form-button'
              loading={loading}
            >
              SIGN IN
            </Button>
          </Form>

          <Text
            onClick={handleForgotPassword}
            type='secondary'
            style={{ cursor: 'pointer' }}
          >
            Forgot your password?
          </Text>
        </Card>
      </Col>
      {/* Login OTP moved to dedicated page /login/otp */}
      {/* Forgot Password Modal */}
      <Modal
        title='Reset Password'
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onOk={handlePasswordReset}
        okText='Send Reset Link'
        cancelText='Cancel'
        confirmLoading={loading}
      >
        <p>
          Enter your registered email address to receive a password reset link.
        </p>
        <Form
          onFinish={handlePasswordReset}
          layout='vertical'
          style={{ marginTop: '20px' }}
        >
          <Form.Item
            required
            validateTrigger='onBlur'
            style={{ marginRight: '16px' }}
          >
            <Input
              type='email'
              value={emailForReset}
              onChange={(e) => setEmailForReset(e.target.value)}
              placeholder='Enter your email'
            />
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title='Verify OTP'
        visible={isOtpModalVisible}
        onCancel={() => setIsOtpModalVisible(false)}
        footer={[
          <Button key='back' onClick={() => setIsOtpModalVisible(false)}>
            Cancel
          </Button>,
          <Button
            key='submit'
            type='primary'
            onClick={handleOtpValidation}
            loading={loading}
          >
            Verify OTP
          </Button>,
        ]}
      >
        <Input
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          placeholder='Enter OTP sent to your email'
        />
      </Modal>
      <Modal
        title='Reset Password'
        visible={isPasswordResetModalVisible}
        onCancel={() => setIsPasswordResetModalVisible(false)}
        footer={[
          <Button
            key='back'
            onClick={() => setIsPasswordResetModalVisible(false)}
          >
            Cancel
          </Button>,
          <Button
            key='submit'
            type='primary'
            onClick={handlePasswordResetSubmit}
            loading={loading}
          >
            Reset Password
          </Button>,
        ]}
      >
        <Form layout='vertical'>
          <Form.Item
            label='New Password'
            rules={[
              { required: true, message: 'Please enter your new password!' },
            ]}
          >
            <Input.Password
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder='Enter new password'
            />
          </Form.Item>
          <Form.Item
            label='Confirm Password'
            rules={[
              { required: true, message: 'Please confirm your new password!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Passwords do not match!'));
                },
              }),
            ]}
          >
            <Input.Password
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder='Confirm new password'
            />
          </Form.Item>
        </Form>
      </Modal>
    </Row>
  );
};

export default Login;
